import { configureStore } from '@reduxjs/toolkit'
import { highScoreSlice } from './DataRetrieverSlice'

export const store = configureStore({
  reducer: {
    highScoreData: highScoreSlice.reducer
  }
})

export type RootState = ReturnType<typeof store.getState>

export type AppDispatch = typeof store.dispatch
